import { Navigate, Outlet } from 'react-router-dom';

export const ProtectedRoutes = ({ condition, navigateAddress }) => {
  return condition ? <Outlet /> : <Navigate to={navigateAddress} />;
};
